/* tslint:disable */
/* eslint-disable */
/**
 * Bioplan API
 * Backend API for Bioplan, an aquaculture production planning tool.
 *
 * Contact: support@optimeeringaqua.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type {Configuration} from '../configuration';
import type {AxiosPromise, AxiosInstance, RawAxiosRequestConfig} from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from '../common';
// @ts-ignore
import {BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap} from '../base';
// @ts-ignore
import type {SensorDataStats} from '../bioplanModels';
/**
 * SensorDataApi - axios parameter creator
 * @export
 */
export const SensorDataApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Export sensor data.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sensorDataExportGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/sensorData/export`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get statistics about sensor data.
     * @param {string} [connectionId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sensorDataStatsGet: async (connectionId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/sensorData/stats`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (connectionId !== undefined) {
        localVarQueryParameter['connectionId'] = connectionId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * SensorDataApi - functional programming interface
 * @export
 */
export const SensorDataApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = SensorDataApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Export sensor data.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async sensorDataExportGet(
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Error>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.sensorDataExportGet(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['SensorDataApi.sensorDataExportGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get statistics about sensor data.
     * @param {string} [connectionId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async sensorDataStatsGet(
      connectionId?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SensorDataStats>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.sensorDataStatsGet(connectionId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['SensorDataApi.sensorDataStatsGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * SensorDataApi - factory interface
 * @export
 */
export const SensorDataApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = SensorDataApiFp(configuration);
  return {
    /**
     *
     * @summary Export sensor data.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sensorDataExportGet(options?: RawAxiosRequestConfig): AxiosPromise<Error> {
      return localVarFp.sensorDataExportGet(options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get statistics about sensor data.
     * @param {SensorDataApiSensorDataStatsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sensorDataStatsGet(
      requestParameters: SensorDataApiSensorDataStatsGetRequest = {},
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<SensorDataStats> {
      return localVarFp
        .sensorDataStatsGet(requestParameters.connectionId, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for sensorDataStatsGet operation in SensorDataApi.
 * @export
 * @interface SensorDataApiSensorDataStatsGetRequest
 */
export interface SensorDataApiSensorDataStatsGetRequest {
  /**
   *
   * @type {string}
   * @memberof SensorDataApiSensorDataStatsGet
   */
  readonly connectionId?: string;
}

/**
 * SensorDataApi - object-oriented interface
 * @export
 * @class SensorDataApi
 * @extends {BaseAPI}
 */
export class SensorDataApi extends BaseAPI {
  /**
   *
   * @summary Export sensor data.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SensorDataApi
   */
  public sensorDataExportGet(options?: RawAxiosRequestConfig) {
    return SensorDataApiFp(this.configuration)
      .sensorDataExportGet(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get statistics about sensor data.
   * @param {SensorDataApiSensorDataStatsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SensorDataApi
   */
  public sensorDataStatsGet(
    requestParameters: SensorDataApiSensorDataStatsGetRequest = {},
    options?: RawAxiosRequestConfig,
  ) {
    return SensorDataApiFp(this.configuration)
      .sensorDataStatsGet(requestParameters.connectionId, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
